import React from 'react'
import Panel from '@sharedComponents/Panel'
import { RecommendedResultsProps } from './types'
import LinkBadge from '@sharedComponents/Links/LinkBadge'
import { LinkBadgeColor, LinkCategory, LinkType } from '@sharedComponents/Links/types'
import { useTranslation } from 'react-i18next'
import { HitCategory } from '@apps/Shared/Services/Search/interfaces'
import includes from 'lodash/includes'

const RecommendedResults = (props: RecommendedResultsProps) => {
    const { t } = useTranslation()

    return props.items && props.items.length > 0 ? (
        <div className="recommended-results">
            <Panel type="info">
                <span className="recommended-results__heading">
                    {t('search.recommendedResults')}
                </span>
                {props.items.map(item => {
                    let linkCategory =
                        LinkCategory[item.hitLinkCategory] || LinkCategory.Page
                    linkCategory =
                        item.hitCategory === HitCategory.EService
                            ? LinkCategory.EService
                            : linkCategory

                    let linkType =
                        linkCategory === LinkCategory.Document
                            ? LinkType.Download
                            : LinkType.Intern
                    linkType = includes(item.url, `http`)
                        ? LinkType.Extern
                        : linkType
                    return (
                        <LinkBadge
                            key={`recommended-item-${item.hitId}`}
                            size="lg"
                            colorTheme={LinkBadgeColor.LightBlue}
                            badgeIcon={item.icon}
                            category={linkCategory}
                            title={item.title}
                            date={item.date}
                            linkType={linkType}
                            teaser={item.excerpt}
                            link={item.url}
                        />
                    )
                })}
            </Panel>
        </div>
    ) : null
}

export default RecommendedResults
